export default {
  props: {
    hasExport: {
      type   : Boolean,
      default: false
    }
  }
}
